<template>
    <div>
        <el-form :model="userForm" :rules="formRules" label-position="right" ref="userForm" label-width="90px" class="demo-ruleForm">
            <el-input v-model="userForm.userPid" type="hidden" style="width: 98%;"></el-input>
            <el-form-item label="用户姓名" prop="userName">
                <el-input ref="userNameEl" v-model="userForm.userName"  readonly="readonly" style="width: 98%" placeholder="输入用户姓名" ></el-input>
            </el-form-item>
            <el-form-item label="用户帐号" prop="userAccount">
                <el-input v-model="userForm.userAccount" readonly="readonly"  style="width: 98%" placeholder="请输入用户帐号"></el-input>
            </el-form-item>
            <el-form-item label="旧 密 码" prop="oldPassword">
                <el-input type="password" v-model="userForm.oldPassword" style="width: 98%" placeholder="请输入旧密码"></el-input>
            </el-form-item>
            <el-form-item label="新 密 码" prop="newPassword">
                <el-input type="password" v-model="userForm.newPassword" style="width: 98%" placeholder="请输入新密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="conuserPassword">
                <el-input type="password" v-model="userForm.conuserPassword" style="width: 98%" placeholder="请输入确认密码"></el-input>
            </el-form-item>
        </el-form>
        <div style="text-align: center">
            <el-button type="primary" style="width: 120px" :disabled="saveButState" @click="submitForm()" v-html="saveButValue"></el-button>
            <el-button type="danger" style="width: 120px" @click="closeWindow()">关 闭</el-button>
        </div>
    </div>
</template>
<script>
    import {appjs} from "@/utiljs/apputil"
    export default {
        components: {
        },
        props: {
            closeWindow: {
                type: Function
            }
        },
        data() {
            return {
                saveButValue: '修改密码',
                saveButState: false,
                userForm: {
                    userPid: '',
                    userName: '',
                    userAccount: '',
                    oldPassword:'',
                    newPassword:'',
                    conuserPassword:''
                },
                formRules: {
                    oldPassword: [
                        { required: true, message: '请输入旧密码', trigger: 'blur' }
                    ],
                    newPassword: [
                        { required: true, message: '请输入新密码', trigger: 'blur' }
                    ],
                    conuserPassword: [
                        { required: true, message: '请输入确认密码', trigger: 'blur' }
                    ]
                }
            }
        },
        created() {
        },
        methods:{
            resertForm() {
                this.saveButValue = '修改密码';
                this.saveButState = false;
                this.userForm.userPid = this.$store.state.loginUser.userPkid;
                this.userForm.userName = this.$store.state.loginUser.userName;
                this.userForm.userAccount = this.$store.state.loginUser.userAccount;
            },
            submitForm() {
                if(this.userForm.newPassword!=this.userForm.conuserPassword){
                    appjs.showErrorMsg("两次输入的密码不一致!")
                    return;
                }
                this.$refs['userForm'].validate((valid) => {
                    if (valid) {
                        let params = this.userForm;
                        this.saveButValue = '修改密码中....'
                        this.saveButState = true;
                        let _self = this;
                        params.userPassword = this.userForm.oldPassword;
                        appjs.httpRequest('user/queryUserPassword',params).then((data)=>{
                            if(data.retCode&&data.retCode!="ok"){
                                appjs.showErrorMsg(data.retMsg);
                                _self.saveButValue = '修改密码';
                                _self.saveButState = false;
                            }else{
                                params.userPassword  = this.userForm.conuserPassword;
                                appjs.httpRequest('user/updateUserPassword',params).then((data)=>{
                                    if(data.retCode&&data.retCode!="ok"){
                                        appjs.showErrorMsg(data.retMsg);
                                        _self.saveButValue = '修改密码';
                                        _self.saveButState = false;
                                    }else{
                                        this.userForm.oldPassword='';
                                        this.userForm.newPassword='';
                                        this.userForm.conuserPassword='';
                                        _self.saveButValue = '修改密码成功';
                                        appjs.showSuccessMsg(data.retMsg);
                                        _self.closeWindow(data.retMsg);
                                    }
                                }).catch((error)=>{
                                    _self.saveButState = false;
                                    _self.loginText = '修改密码';
                                    appjs.showErrorMsg("异常：" + error)
                                })
                            }
                        }).catch((error)=>{
                            _self.saveButState = false;
                            _self.loginText = '修改密码';
                            appjs.showErrorMsg("异常：" + error)
                        })
                    }
                });
            }
        }
    }
</script>
